export const ANIMATIONS = {
  goal: 10,
  yellowCard: 11,
  redCard: 12,
  penaltyMiss: 53,
  matchStart: 32,
  matchEnd: 33,
  breakTimeStarted: 9999,
  breakTimeEnded: 9
};